import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/dropDowns')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/dropDown' })
  },
})
